export default {
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}



// WEBPACK FOOTER //
// ./src/components/game-style.scss.js